import Carousel from 'bootstrap/js/dist/carousel';

const teamCarouselElem = document.getElementById('team-carousel');
const teamCarouselSlides = teamCarouselElem.querySelectorAll('.team-carousel-item');
const prevButton = teamCarouselElem.querySelector('.carousel-control-prev');
const nextButton = teamCarouselElem.querySelector('.carousel-control-next');

const carousel = new Carousel(teamCarouselElem, {
  interval: false,
  wrap: false,
  touch: false,
})

function disableButton(button) {
  button.setAttribute('disabled','');
}

function enableButton(button) {
  button.removeAttribute('disabled');
}

function updateButtons(index, carouselLength) {
  if (carouselLength > 1) {
    if (index === 0) {
      disableButton(prevButton);
      enableButton(nextButton);
    } else if (index === (carouselLength - 1)) {
      disableButton(nextButton);
      enableButton(prevButton);
    } else {
      enableButton(nextButton);
      enableButton(prevButton);
    }
  } else {
    disableButton(prevButton);
    disableButton(nextButton);
  }
}

teamCarouselElem.addEventListener('slide.bs.carousel', function (event) {
  updateButtons(event.to, teamCarouselSlides.length);
  teamCarouselElem.scrollIntoView();
});
